import React from 'react';
import { Button, Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
const StepOne = ({ activeStep, setActiveStep }) => {
    const navigation = useNavigate();
    const submitForm = () => {
        navigation("/thankyou");
    }
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Medical Information (DOT Physical Exam)</h5>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Medical Examiner's Certificate Number:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Medical Examiner's Certificate Number" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Medical Examination Date:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Medical Examination Date" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Expiration Date of Medical Certificate:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Expiration Date of Medical Certificate" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Medical Examiner’s Name:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Medical Examiner’s Name" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Medical Examiner’s Contact Information:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Medical Examiner’s Contact Information" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Expiration Notification:</Form.Label>
                                                <Form.Check type="checkbox" label="Receive reminders" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(8)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={submitForm}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepOne;